import { cn } from '@/shared/utils/cn';
import React from 'react';

export interface ListItemRadioProps {
  children: React.ReactNode;
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  rightContent?: React.ReactNode;
  className?: string;
}

export const ListItemRadio: React.FC<ListItemRadioProps> = ({
  children,
  selected = false,
  disabled = false,
  onClick,
  rightContent,
  className,
}) => {
  return (
    <div
      onClick={disabled ? undefined : onClick}
      className={cn(
        'ui-flex ui-items-center ui-gap-8 ui-rounded-control-sm ui-px-8 ui-py-6 ui-transition-all',
        {
          'ui-cursor-pointer': !disabled,
          // Hover: gris claro
          'hover:ui-bg-fill-hover': !disabled && !selected,
          // Selected: azul oscuro con texto blanco
          'ui-bg-fill-brand ui-text-on-color': selected,
          'ui-cursor-not-allowed ui-opacity-50': disabled,
        },
        className,
      )}
    >
      {/* Radio Button */}
      <div
        className={cn(
          'ui-h-16 ui-w-16 ui-rounded-control-pill ui-transition-all',
          selected
            ? 'ui-bg-on-color ui-border-[4px] ui-border-on-color'
            : 'ui-border ui-border-neutral-300 ui-bg-fill',
        )}
      />

      {/* Content */}
      <div className="ui-flex ui-flex-1 ui-items-center ui-justify-between">
        <span
          className={cn(
            'ui-text-body-sm-regular ui-font-body-sm-medium ui-leading-body-sm-regular ui-tracking-body-sm',
            {
              'ui-text-on-color': selected,
              'ui-text-primary': !selected,
            },
          )}
        >
          {children}
        </span>
        {rightContent && (
          <span
            className={cn(
              'ui-text-body-xs-regular ui-font-body-xs-regular ui-leading-body-xs-regular ui-tracking-body-xs',
              {
                'ui-text-on-color ui-opacity-70': selected,
                'ui-text-tertiary': !selected,
              },
            )}
          >
            {rightContent}
          </span>
        )}
      </div>
    </div>
  );
};
